import { AllIssuers } from "@trellisconnect/types/dist/src/enums/AllIssuers";
import { InsuranceType } from "../constants";
import { NOT_INSURED_ISSUER_SLUG } from "../lib/constants";
import isAAAIssuer from "./isAAAIssuer";
import logoV3List from "../../logosV3List.json";
var IMAGE_LOGOS_BASE_PATH = "/assets/images/logos";
var DEFAULT_CARD_HOME_LOGO_PATH = "".concat(IMAGE_LOGOS_BASE_PATH, "/default_home_logo.svg");
var DEFAULT_CARD_AUTO_LOGO_PATH = "".concat(IMAGE_LOGOS_BASE_PATH, "/default_auto_logo.svg");
export function getCleanId(id) {
    return id.toLocaleLowerCase().replace(/ /gi, "").replace(/\.*/g, "");
}
export function getLogoFileName(id) {
    var cleanId = getCleanId(id);
    // We want to use the same image for all AAA issuers
    var isAAA = isAAAIssuer({ id: cleanId });
    var imageFileName = isAAA ? "aaa" : cleanId;
    var image = logoV3List.find(function (src) {
        return isAAA ? src.includes(imageFileName) : src.split(".")[0] === imageFileName;
    });
    if (image) {
        return "".concat(IMAGE_LOGOS_BASE_PATH, "/v3/").concat(image);
    }
}
var getLogoV3ImgSrc = function (id, insuranceType) {
    var fallbackImage = insuranceType === InsuranceType.Home
        ? DEFAULT_CARD_HOME_LOGO_PATH
        : DEFAULT_CARD_AUTO_LOGO_PATH;
    if (!id) {
        return fallbackImage;
    }
    if (id === NOT_INSURED_ISSUER_SLUG || id === AllIssuers.OTHER) {
        return "/assets/icons/unknown-issuer.svg";
    }
    var image = getLogoFileName(id);
    return image || fallbackImage;
};
export default getLogoV3ImgSrc;
